
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-08-03-react-three-fiber-5-viewport",
      function () {
        return require("private-next-pages/blogs/2024-08-03-react-three-fiber-5-viewport/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-08-03-react-three-fiber-5-viewport"])
      });
    }
  